import DOMPurify from "dompurify";
import { EDITORIAL_CONFIG, EMBED_CONFIG } from "../composables/sanitize-config";

// This directive is the sanitizing wrapper around v-html. It runs DOMPurify
// (an HTML sanitizer library) on the value BEFORE assigning to innerHTML,
// which strips script tags, event handlers and disallowed attributes. This
// assignment pattern is the recommended DOMPurify usage — see
// https://github.com/cure53/DOMPurify#readme.
const sanitize = (value, mode) => {
    if (value === null || value === undefined) return "";
    const config = mode === "embed" ? EMBED_CONFIG : EDITORIAL_CONFIG;
    return DOMPurify.sanitize(String(value), config);
};

const applySanitized = (el, value, mode) => {
    const clean = sanitize(value, mode);
    el.innerHTML = clean;
};

export default {
    mounted(el, binding) {
        applySanitized(el, binding.value, binding.arg);
    },
    updated(el, binding) {
        if (binding.value !== binding.oldValue) {
            applySanitized(el, binding.value, binding.arg);
        }
    },
};
